// CONTENT.JS
//
// This File contains the contents of the website!
// Changes in this file only take effect, after: npm run build
//
// The website content is specified as a javascript object literal below.
// The "content"-fields, below can be an object or an array of objects. Content objects can be nested.
//
// Hint: Use ` ` for multi-line strings. (This is what requires the build step - as it is not supported by all browsers)
//
// Supported Objects in content fields:
//
// // Simple HTML:
// 	{
//		type: "html"
//		value: "<p>some html<p>"
// 	}
// // Expandable: Allows to show/hide content by clicking on title
// 	{
// 		type: "expandable",
// 		title: "The Title",
// 		content: []
// 	}
// // Cards: Allows to display content in cards
// 	{
// 		type: "cards", // use "cards-light" for dark background
// 		cards:
// 		[
// 			{
// 				card: "1",
// 				content: []
// 			},
// 			{
// 				card: "2",
// 				content: []
// 			},
// 		]
// 	}
// // Table:
// 	{
// 		type: "table",
// 		widths: ['4em','auto','auto','auto'], // column widths
// 		// rowStyle: ["font-weight: bold;font-size: 1.2em", "font-weight: bold; background-color: #2B628D; color: white","font-size: 0.9em;","font-size: 0.9em;","font-size: 0.9em;","font-size: 0.9em;","font-size: 0.9em;"],
// 		// colStyle: ["font-weight: bold"],
// 		// cellStyle: "",

// 		// rowClass: [],
// 		// colClass: [],
// 		// cellClass: "",

// 		table: [
// 			["cell11","cell12","cell13","cell14"], // row 1
// 			["cell21","cell22","cell23","cell24"], // row 2
// 		]
// }
// Components:
// 	{
// 		type: "component:co-sponsors" / "component:sponsors" / "component:speakers" / "component:organizers"
// 	}

// Styles AND Classes:
// Except for Components (i.e., type: "component:..."). All content objects support fields "class" & "style" to add specific classes and styles to the contents.

// Timing:
// Every content object or property (simple properties can be made objects as {value: string})
// can have "from" and / or "till" properties that specify when they are to be displayed.
// If there are multiple choices depending on the date. Arrays of {value: x, from:y, till:z} are possible. The first match will be displayed.
// Time Format is: 2020-09-29T14:23:00 // all time must be specified in CEST = UTC+2
// Examples:
// header:{
//	 message: [{value: "Register Now", till:"2020-09-29T08:00"},{value: "Ongoing",from:"2020-09-29T08:00"}]
// }
//

// Icons: https://fontawesome.com/v5.3.1/icons?d=gallery

export var content = {
	copyrightText: "Copyright © IEEE Princeton Central Jersey Section 2015 - ",
	menu: [
		{ text: "Home", target: "page-top" },
		{ text: "Venue", target: "venue" },
		{ text: "Partners", target: "partners" },
		{ text: "Speakers", target: "speakers" },
		{ text: "Registration", target: "registration" },
		{ text: "Agenda", target: "agenda" },
		{ text: "Exhibition", target: "exhibition" },
		{ text: "Committee", target: "committee" },
	],
	header: {
		title: "<span>IEEE 6G Summit<br>Dresden 2025</span>",
			//'<img alt="1st IEEE 6G Summit Dresden" src="img/heading_website.svg" class="tooltiptextself" style="height:2.5em; margin-bottom: 0em; max-width:100%">',
		dates: "May 14&ndash;15, 2025 in Dresden, Germany",
		message: "",
		buttons: [
			//{
			//	text: "Follow Us",
			//	icon: "fab fa-twitter", // FA Icon
			//	target: "https://twitter.com/5g_lab",
			//},
			{
				text: "IEEE Chips Summit",
				icon: "fas fa-users", // FA Icon
				target: "https://chipssummit.org/",
			},
			//  {
			//   	text: "Become a Sponsor",
			//  	icon: "fa fa-file-pdf",
			//   	target: "6GSummit_PatronageFlyer_2025.pdf"
			//  },
			{
				text: "LinkedIn",
				icon: "fab fa-linkedin",
				target: "https://www.linkedin.com/company/5g-lab-gmbh/",

			},
				 		{
			 	text: "Impressions",
			 	icon: "fa fa-image",
			 	target: "https://5glab.de/impressions-of-the-10th-ieee-6g-summit-2025",
			 },
			// {
			// 	text: "Add to Calendar",
			// 	icon: "far fa-calendar-alt",
			// 	target: "6G-Summit-Dresden-2024.ics",
			// 	till: "2024-05-14T01:00:00"
			// },
			// {
			// 	text: "Agenda",
			// 	icon: "fa fa-file-pdf",
			// 	target: "Agenda.pdf",
			// },
	 		// {
			//  	text: "Impressions",
			//  	icon: "fa fa-image",
			//  	target: "https://5glab.de/impressions-of-the-9th-ieee-6g-summit-2024/",
			//  },
			 {
			 	text: "Register Now",
			 	icon: "fa fa-pen-nib",
			 	target: "#registration",
			 	till: "2023-05-09T18:00:00",
			 },
			// {
			// 	text: "Web App",
			// 	icon: "fa fa-external-link-alt",
			// 	target: "https://whova.com/portal/webapp/gsumm_202105/"
			// },
			{
				text: "Revisit 2024 Summit",
				icon: "fa fa-redo",
				target: "/dresden-2024"
			},

			// {
			// 	text: "Register Now",
			// 	//icon: "play", // FA Icon
			// 	target: "registration",
			// 	till: "2020-10-08T23:30:00"
			// },
			
		],
	},
	sections: [

		{
			name: "about",
			background: "light",
			content: [

				// { // Day 1
				// 	type: "html",
				// 	from: "2024-05-13T08:00:00",
				// 	till: "2024-05-13T19:00:00",
				// 	value: `
				// 	<div style="margin: -1em 0 1em 0; display: flex; justify-content: center; align-items: center; flex-direction: column; border-bottom: 1px solid lightgray;">

				// 		<div style="font-size: 1.5em; padding: 1em 2em;">
				// 		<p><strong>&gt;&nbsp;Welcome to Day 1&lt;</strong></p>
				// 		<div>
				// 	<div>
				// 	`

				// },
				// { // Day 2
				// 	type: "html",
				// 	from: "2024-05-14T08:00:00",
				// 	till: "2024-05-14T19:00:00",
				// 	value: `
				// 	<div style="margin: -1em 0 1em 0; display: flex; justify-content: center; align-items: center; flex-direction: column; border-bottom: 1px solid lightgray;">

				// 		<div style="font-size: 1.5em; padding: 1em 2em;">
				// 		<p><strong>&gt;&gt;&nbsp;Welcome to Day 2&lt;&lt;</strong></p>
				// 		<div>
				// 	<div>
				// 	`

				// },
				// { // Live Stream Advertisement before first live stream
				// 	type: "html",
				// 	from: "2023-05-08T05:00:00",
				// 	till: "2023-05-10T07:55:00",
				// 	value: `
				// 	<div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">

				// 		<div style="font-size: 1.5em; padding: 1em 2em; border-radius: 1em; background: #eee;">
				// 		<p><strong>On Wednesday</strong></p>
				// 		<p style="margin-top: -0.5em">Plenary sessions will be live-streamed<p>
				// 		<div>
				// 	<div>
				// 	`

				// },
				// { // Live Stream Advertisement before second live stream
				// 	type: "html",
				// 	from: "2023-05-10T10:45:00",
				// 	till: "2023-05-10T16:25:00",
				// 	value: `
				// 	<div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">

				// 		<div style="font-size: 1.3em; padding: 1em 2em; border-radius: 1em; background: #eee;">
				// 		<p style="margin:0;padding:0">Plenary Closing Session will be live-streamed @16:30 CEST.<p>
				// 		<div>
				// 	<div>
				// 	`

				// },



				// { // Goodbye Message
				// 	type: "html",
				// 	from: "2024-05-14T19:15:00",
				// 	value: `
				// 	<div style="margin: -1em 0 1em 0; display: flex; justify-content: center; align-items: center; flex-direction: column; border-bottom: 1px solid lightgray;">

				// 		<div style="font-size: 1.5em; padding: 1em 2em;">
				// 		<p><strong>&gt;&nbsp;Thank you for participating&nbsp;&lt;</strong></p>
				// 		<div>
				// 	<div>
				// 	`

				// },
				// {	// Recordings
				// 	type: "html",
				// 	value: `
				// 	<div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
				// 		<h2>Recordings</h2>
				// 		<div style="display:flex; justify-content: center; align-items: top; flex-direction: row; margin-bottom: 3em; flex-wrap: wrap; gap: 2em;">
				// 			<div>
				// 			<h3>Welcome Session</h3>
				// 			<a title="open recording" href="https://player.vimeo.com/video/825426511?h=d2284d08c2"><img alt="Welcome Session" src="img/welcome_thumbnail.jpg" style="width: 350px; border: 1px solid gray;"></a>

				// 			</div>
				// 			<div>
				// 			<h3>Closing Session</h3>
				// 				<a title="open recording" href="https://player.vimeo.com/video/825375241?h=cdd261d29d"><img alt="Closing Session" src="img/closing_thumbnail.jpg" style="width: 350px; border: 1px solid gray;"></a>
				// 			</div>
				// 		</div>
				// 	</div>
				// 	`

				{
					// Teaser Video
					type: "html",
					value: `
					<div style="display: flex; justify-content: center; align-items: center; flex-direction: column; margin-bottom: 1em">
						<h2 style="margin-bottom: 0.2em; line-height: 0.7;">Teaser for 6G Summit Dresden 2025</h2>
						<h4 style="margin-bottom: 0.6em; line-height: 3;">(A Recap from 6G Summit Dresden 2024)</h4>
						<div style="position: relative; overflow:hidden; padding-top: 45%; width: 80%">
							<iframe
								style="position:absolute;top:0;left:0;width:100%;height:100%"
								src="https://player.vimeo.com/video/1021978972?h=d901c74662&amp;title=0&amp;byline=0&amp;portrait=0&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
								frameborder="0" allow="autoplay; fullscreen; picture-in-picture"
								allowfullscreen autoplay>
							</iframe>
						</div>
					</div>
					<script src="https://player.vimeo.com/api/player.js"></script>
					`
				},

				// { // Live Stream of Welcome Session
				// 	type: "html",
				// 	from: "2023-05-10T07:55:00",
				// 	till: "2023-05-10T10:45:00",
				// 	value: `
				// 	<div style="display: flex; justify-content: center; align-items: center; flex-direction: column; margin-bottom: 3em;">
				// 		<h2 style="margin-bottom: 1em;">Live-Stream: Plenary Welcome Session</h2>
				// 		<div style="position: relative; overflow:hidden; padding-top: 56.25%; width: 80%">
				// 			<iframe
				// 				style="position:absolute;top:0;left:0;width:100%;height:100%"
				// 				src="https://vimeo.com/event/3344892/embed"
				// 				frameborder="0" allow="autoplay; fullscreen;picture-in-picture"
				// 				allowfullscreen autoplay>
				// 			</iframe>
				// 		</div>
				// 	</div>
				// 	`

				// },



				// { // Live Stream of Closing Session
				// 	type: "html",
				// 	from: "2023-05-10T16:25:00",
				// 	till: "2023-05-10T19:15:00",
				// 	value: `
				// 	<div style="display: flex; justify-content: center; align-items: center; flex-direction: column; margin-bottom: 3em;">
				// 		<h2 style="margin-bottom: 1em;">Live-Stream: Closing Session</h2>
				// 		<div style="position: relative; overflow:hidden; padding-top: 56.25%; width: 80%">
				// 			<iframe
				// 				style="position:absolute;top:0;left:0;width:100%;height:100%"
				// 				src="https://vimeo.com/event/3344892/embed"
				// 				frameborder="0" allow="autoplay; fullscreen;picture-in-picture"
				// 				allowfullscreen autoplay>
				// 			</iframe>
				// 		</div>
				// 	</div>
				// 	`

				// },


				{
					type: "html",
					// <p>IEEE 5G++ Summit Dresden has become a prominent annual fixture on the road to 6G. The well-known high-impact conference brings together industry leaders, innovators, and researchers from industry and academia to exchange ideas that will help to drive standards and rapid deployment of 5G++ technologies. The IEEE 5G++ Summit Dresden takes a holistic approach to 5G++ system design, ranging from silicon hardware, wireless interfaces, networks, edge clouds all the way up to Tactile Internet applications.</p>
					value: `
					<p>Embark on a journey into the future of connectivity at the IEEE 6G Summit Dresden 2025! Save the date for May 14 & 15, 2025 and join us at Messe Dresden for a dynamic two-day event
					that unites industry leaders, academic pioneers, and tech enthusiasts. Brought to you by IEEE, 5G Lab Germany, and TU Dresden, the Summit will captivate with insightful talks by global
					professionals and forward-thinking industry leaders. Immerse yourself in an exhibition showcasing unique demonstrations from a diverse mix of global players, startups, and academic institutions.
					This is your opportunity to engage in the exchange of groundbreaking ideas, explore emerging trends, and discover exciting business prospects that will shape the landscape of future mobile communications.
					</p>
					<p>Be a part of the 10th chapter of this influential conference, where innovation converges with expertise in unexpected ways. See you there, ready to witness and contribute to the evolution of the next generation of mobile communications!</p>
					`,
				},
				 {
				 	type: "html",
				// 	// <p>IEEE 6G Summit Dresden has become a prominent annual fixture on the road to 6G. The well-known high-impact conference brings together industry leaders, innovators, and researchers from industry and academia to exchange ideas that will help to drive standards and rapid deployment of 5G++ technologies. The IEEE 6G Summit Dresden takes a holistic approach to 6G system design, ranging from silicon hardware, wireless interfaces, networks, edge clouds all the way up to Tactile Internet applications.</p>
				 	value: `
				 	<h2 style="margin-bottom: 1em;">Startup Call</h2>
				 	<p>We are thrilled to announce our startup call for this impactful industry-focused event. We invite startups to apply for the opportunity to pitch their company and products in one of our keynote sessions and get a presentation area in our exhibition.</p>
				 	<p>Interested in showcasing your startup at our event? </p> 
					<p><b> Download our <a href="Startup-Call-6G-Summit.pdf">Startup Call</a> for more information. </b></p>
					<h4>Our deadline for applications for the Startup Call has been extended to <b>March 21, 2025! </b> Take your chance!</h4>
				 	`,
				 },
				//{
				//	type: "html",
				//	value: `
				//		<h2 style="margin-bottom: 1em;" >Leading the Way: IEEE 6G Summit Dresden 2025 Promotes Sustainability</h2>
				//		<p>Join us at IEEE 6G Summit 2025 as we lead the way in sustainable practices. Together, we'll minimize our environmental impact and shape a more sustainable future for telecommunications. Learn more in our <a target="_blank" rel="noopener noreferrer" href="6G_Summit_Sustainability.pdf">sustainability statement</a>.</p>
				//	`
				// },
				{
					type: "html",
					value: `
					<cosponsors></cosponsors>
					`,
				},
			],
		},
		{
			name: "venue",
			title: "Venue",
			background: "venue",
			content: [
				{
					type: "html",
					style: "font-size: 1.2em",
					value: `

					<p><strong>Location:</strong> <a style="margin-left: 0.6em; display:inline-block" href="https://www.google.com/maps/place/Messering+6,+01067+Dresden/" target="_blank">Messe Dresden</a> </p>
					<p><strong>Accommodation:</strong> <a style="margin-left: 0.6em" href="https://www.hrs.de/list?location=%25765608&orderBy=Recommendations&startDateDay=13&startDateMonth=5&startDateYear=2025&endDateDay=15&endDateMonth=5&endDateYear=2025&lang=de&currency=EUR&adults=1&singleRooms=1&intcmp=btcweb" target="_blank">Book a Hotel</a></p>
					<p><strong>Feel free to your room in the Maritim Hotel
					<a href="https://app.mews.com/distributor/3683ab73-7b97-4ba0-b0ff-b28f00e1aeab?mewsAvailabilityBlockId=b79622ea-b7f0-4fe2-ba31-b2a100c7de25&mewsStart=2025-05-10&mewsEnd=2025-05-18">here</a>.  </p></strong>
					`,
				},
				//Venue plan here
				{
					type: "html",
					value: `
					<div style="margin-top:2em; width: 100%; display: flex; justify-content: center; flex-direction: column; gap: 1em;">
						<h2>Venue Plan</h2>
						<a title="open picture separately" class="raw" href="Venue.svg"><img alt="Venue Plan" src="Venue.svg" style="width:900px; max-width:90%"></a>
					</div>
					`,
				}
			],
		},
		{
			name: "partners",
			title: "Partners",
			content: [
				{
					type: "html",
					value: `



						 <sponsors json="data/sponsors.json" pictures="data/sponsors/" :exclude="['Exhibitors', 'Exhibitors (Chips)']"></sponsors>
						 <p>Interested in becoming a patron? Check out our <a href="6GSummit_PatronageFlyer_2025.pdf">Patronage Brochure <i class="fa fa-file-pdf"></i></a> .</p>
						 <p>To arrange your individual patronage package, please contact <a href="mailto:nicole.flechs@tu-dresden.de">Nicole Flechs</a>.</p>
						 <div style="margin-top: 5em"></div>
						<h2> Exhibitors </h2>
						<p>In conjunction with the <a href="https://chipssummit.org">IEEE Chips Summit</a><p>
						<!--div class="ruler"><div class="ru"></div><div aria-hidden="true" class="sym fa fa-star"></div><!----><div class="ru"></div></div-->
						<sponsors json="data/sponsors.json" pictures="data/sponsors/" :include="['Exhibitors']":headings=false></sponsors>
						

						 `
						 //<p>Interested in becoming a patron? Check out our <a href="6GSummit2024_SponsoringFlyer_small.pdf">Patronage Brochure <i class="fa fa-file-pdf"></i></a> .</p>
				},
			],
		},
		{
			name: "speakers",
			title: "Speakers",
			background: "dark",
			content: [
				 {
				 	type: "html",
				 	value: `
				 	<p>Interested in pitching your startup at one of our keynote sessions? Download our <a href="Startup-Call-6G-Summit.pdf">Startup Call</a> for more information.</p>
				 	`,
				 },
				{
					type: "component:speakers",
				},
			],
		},

		{
			name: "registration",
			title: "Registration",
			content: [

				{
					type: "html",
					value: `
					<p><a href="DCCF25-TermsandConditions.pdf">Terms and Conditions</a> apply.</p>
					`,
				},
				  {
				  	type: "html",
				//  	till: "2024-05-13T18:00:00",
				  	value: `
				  	<p><b><p style="margin-top: -0em; font-size: 1.5em;">Registration is now available. Please register <a style="font-weight: bold" href="https://IEEE-6G-and-Chips-Summit.eventbrite.de" target="_blank">&gt;&gt;&nbsp;here&nbsp;&lt;&lt;</a>&nbsp;.</p></b></p>
					<p><p style="margin-top: -0em; font-size: 1.5em;">Please note: The registration portal is for the IEEE 6G Summit Dresden and the IEEE Chips Summit. <br> The purchase of a participation ticket authorizes access to both events.</p>
				  	`,
				  },
				//  {
				//  	type: "html",
				//  	from: "2023-05-09T18:00:00",
				//  	value: `
				//  	<p><strong>Note:</strong> Online registration is not available anymore.</p>
				//  	`
				//  },

				  {
				  	type: "html",
				  	value: `
				  	<h2 style="margin-bottom: 1em;">Prices</h2>
				  	<label class="check-label" style="margin-top: 0; font-size: 1.3em; cursor: pointer;"><input type="checkbox" v-model="l.includeVat">Include VAT in prices</label>
				  	<div style="margin-bottom: -1em"></div>
				  	`,
				  },
				  {
				  	type: "table",
				  	widths: ["12em", "auto", "auto", "auto"],
				  	rowStyle: ["font-weight: bold; border-bottom: 1px solid gray; background-color: rgb(14, 83, 116); color: white;"],
				  	colStyle: ["font-weight: bold;"],
				  	cellStyle: "font-size: 1.2em;",

				  	 		 rowClass: [],
				  	 		 colClass: [],
				  	 		 cellClass: "",
				  	table: [
				  		[``, "Standard", "Late", "Last Minute / On-Site"],
				  		["Regular <sup>1</sup>", "{{getPrice(575)}} €", "{{getPrice(625)}} €", "{{getPrice(675)}} €"],
						["IEEE Member <sup>1</sup>", "{{getPrice(525)}} €", "{{getPrice(575)}} €", "{{getPrice(625)}} €"],
						["Student <sup>1,3</sup>", "{{getPrice(300)}} €", "{{getPrice(325)}} €", "{{getPrice(350)}} €"],
				  		[
				  			"Networking Only <sup>2</sup>",
				  			"{{getPrice(125)}} €",
				  			"{{getPrice(150)}} €",
				  			"{{getPrice(175)}} €",
				  		],
				  	],
				  },
				  {
				  	type: "html",
				  	value: `
				  	<div style="font-size: 0.9em">
				  		<p style="margin-top: -1em">Prices <span v-show="!l.includeVat">excluding 19% VAT that apply additionally</span><span v-show="l.includeVat">including 19% VAT</span>.</p>
				  		<p><sup>1</sup> Includes participation in the conference at Messe Dresden on May 14 + 15, coffee break and lunch catering, and participation in the conference dinner on May 14.</p>
				  		<p><sup>2</sup> Includes participation in the conference dinner on May 14.</p>
						<p><sup>3</sup> BA/MA/Dipl. students only.</p>
				  	</div>
				  	`,
				  },
				  {
				  	type: "html",
				  	value: `
				  	<h2 style="margin-bottom: 1em;">Registration Deadlines</h2>
				  	<div style="display: inline-block;">
				  	<table style="font-size: 2.2rem; line-height: 2">
				  		<tr>
				  			<td style="font-weight: bold; ">Standard</td>
				  			<td style="width: 8em;">April 15, 2025</td>
				  			<td>(23:30 CEST)</td>
				  		</tr>
				  		<tr>
				  			<td style="font-weight: bold">Late</td>
				  			<td>May 6, 2025</td>
				  			<td>(23:30 CEST)</td>
				  		</tr>
				  		<tr>
				  			<td style="font-weight: bold">Last&nbsp;Minute/ On-Site</td>
				  			<td>May 15, 2025 </td>
				  		</tr>
				  	</table>
				  	</div>
				  	`
				  }


			],
		},
		{
			name: "agenda",
			title: "Agenda",
			background: "dark",
			content: [
				// {
				// 	type: "html",
				// 	value: `<p>To be announced.</p>`,
				// }

				// {
				// 	type: "html",
				// 	value:	`
				// 	<p> This year's IEEE 6G Summit is part of the Dresden Chips & Communications Festival 2025 (DCCF). The DCCF and its many sub-events form versatile days full scientific dialogue, exciting talks, and innovations on 6G and Beyond 5G. In addition to the high impact IEEE 6G Summit Dresden with presentations from leaders in academia and industry on May 15, the DCCF will also feature the first IEEE Chips Summit Dresden on May 14 with which it will share a two-day exhibition showcasing the potential of 5G and 6G technology. </p>
				// 	<h2> Overview </h2>		
				// 	<div style="width: 100%; display: flex; justify-content: center;">	
					
				// 	<img alt="Agenda" src="DCCF_Agenda_transparent_Workshops.svg" width="90%">
				// 	</div>
				
				// 	`,
				// },
				
				// {
				// 	type: "html",
				// 	// <p>IEEE 5G++ Summit Dresden has become a prominent annual fixture on the road to 6G. The well-known high-impact conference brings together industry leaders, innovators, and researchers from industry and academia to exchange ideas that will help to drive standards and rapid deployment of 5G++ technologies. The IEEE 5G++ Summit Dresden takes a holistic approach to 5G++ system design, ranging from silicon hardware, wireless interfaces, networks, edge clouds all the way up to Tactile Internet applications.</p>
				// 	value: `
				// 	<h2>Monday, May 13<sup>th</sup></h2>
				// 	<p> 5G/6G will be a revolution in the industry, it has been announced, but so far there is none. Probably there won't be one, but rather an evolution that needs to be driven by all stakeholders, and there are many, necessary for it to be a success. With this track, we want to stimulate discussions between verticals, academia, and the telecom industry to achieve a recognizable (r)evolution of 5G/6G in the shop floor of vertical industry.</br></p>

				// 	`,
				// },
				// {
				// 	type: "html",
				// 	// <p>IEEE 5G++ Summit Dresden has become a prominent annual fixture on the road to 6G. The well-known high-impact conference brings together industry leaders, innovators, and researchers from industry and academia to exchange ideas that will help to drive standards and rapid deployment of 5G++ technologies. The IEEE 5G++ Summit Dresden takes a holistic approach to 5G++ system design, ranging from silicon hardware, wireless interfaces, networks, edge clouds all the way up to Tactile Internet applications.</p>
				// 	value: `
				// 	<div style="width: 100%; display: flex; justify-content: center;">
				// 	<div style="border: 1px solid white; max-width: 95%; overflow-x: auto;">
				// 			<img alt="Agenda" src="AgendaMonday0429.svg" width="900px">
				// 		</div>
				// 		</div>
				// 	`,
				// },
				{
					type: "html",
					value: `
					
					<h2>Wednesday, May 14<sup>th</sup></h2>
				<div style="width: 100%; display: flex; justify-content: center;">
					<div style="border: 3px solid white; width: 90%; height:90%; overflow-x: auto;justify-content: center;">	 
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg width="100%" height="100%" viewBox="0 0 2666 1273" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;">
    <g id="_6G-Workshop-Day-White" serif:id="6G Workshop Day White" transform="matrix(1.09638,0,0,0.34163,-9761.23,-60.6808)">
        <rect x="8903.17" y="177.622" width="2430.92" height="3725.94" style="fill:none;"/>
        <g transform="matrix(3.8004,0,0,12.1964,9500.3,569.302)">
            <text x="12.917px" y="25.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">11:00</text>
            <text x="48.917px" y="25.516px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">WORKSHOP:</text>
            <text x="112.657px" y="25.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">Ph<tspan x="124.167px " y="25.516px ">y</tspan>sical La<tspan x="160.467px 165.457px " y="25.516px 25.516px ">ye</tspan>r Security</text>
            <text x="415.423px" y="25.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:9px;fill:white;">HAMBUR<tspan x="454.609px " y="25.516px ">G</tspan> 1</text>
            <text x="48.917px" y="43.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:9px;fill:white;"><a href="https://6gphysec.org/program-workshop-on-physical-layer-security-for-wireless-networks-date-14th-may-2025-9-am-1-pm/"> Click for a look at the program</a></text>
            <text x="12.917px" y="70.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">12:30  <tspan x="48.917px " y="70.516px ">L</tspan>unch Break</text>
            <text x="12.917px" y="96.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">13:30</text>
            <text x="48.917px" y="96.516px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">WORKSHOP:</text>
            <text x="112.657px" y="96.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">Ne<tspan x="125.157px " y="96.516px ">x</tspan>t-Gener<tspan x="164.617px " y="96.516px ">a</tspan>tion AI (6G-RIC)</text>
            <text x="415.423px" y="96.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:9px;fill:white;">HAMBUR<tspan x="454.609px " y="96.516px ">G</tspan> 1</text>
            <text x="12.917px" y="121.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">15:00  <tspan x="48.917px " y="121.516px ">C</tspan>offee Break</text>
            <text x="12.917px" y="149.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">15:30</text>
            <text x="48.917px" y="149.516px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">WORKSHOP:</text>
            <text x="112.657px" y="149.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">Green Communication for 6G (6G-RIC &amp; Green ICT @ FMD<tspan x="369.837px " y="149.516px ">)</tspan></text>
            <text x="415.423px" y="149.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:9px;fill:white;">HAMBUR<tspan x="454.609px " y="149.516px ">G</tspan> 1</text>
            <text x="12.917px" y="174.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">17:00 <tspan x="48.917px " y="174.516px ">C</tspan>offee Break</text>
            <text x="12.917px" y="202.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">17:30</text>
            <text x="48.917px" y="202.516px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">WORKSHOP:</text>
            <text x="112.657px" y="202.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">Wireless Design in the 6G Er<tspan x="236.587px " y="202.516px ">a</tspan>: Acceler<tspan x="279.127px " y="202.516px ">a</tspan>te y<tspan x="300.087px " y="202.516px ">o</tspan>ur R&amp;D</text>
            <text x="415.423px" y="202.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:9px;fill:white;">HAMBUR<tspan x="454.609px " y="202.516px ">G</tspan> 1</text>
            <g transform="matrix(10,0,0,10,110.007,217.516)">
            </g>
            <text x="48.917px" y="217.516px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;"><tspan x="48.917px " y="217.516px ">w</tspan>ith MA<tspan x="85.697px " y="217.516px ">T</tspan>LAB</text>
        </g>
        <g transform="matrix(3.64391,0,0,12.4788,8888.55,-9665.44)">
            <path d="M12.441,825.236L661.505,825.236" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.96px;"/>
        </g>
        <g transform="matrix(3.64391,0,0,12.4788,8888.55,-10303.3)">
            <path d="M12.441,849.856L661.505,849.856" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.96px;"/>
        </g>
        <g transform="matrix(2.5525,0,0,12.5986,9485.52,-3577.09)">
            <path d="M13.154,434.712L710.481,434.712" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:1.1px;"/>
        </g>
        <g transform="matrix(2.5525,0,0,12.5986,9485.52,-4193.89)">
            <path d="M13.154,434.712L710.481,434.712" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:1.1px;"/>
        </g>
        <g transform="matrix(3.66712,0,0,12.4809,8888.25,-41.638)">
            <path d="M12.914,270.606L658.12,270.606" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.96px;"/>
        </g>
        <g transform="matrix(2.5525,0,0,12.5986,9485.51,-2983.08)">
            <path d="M13.157,406.863L710.483,406.863" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:1.1px;"/>
        </g>
        <g transform="matrix(2.5525,0,0,12.5986,9485.51,-3599.89)">
            <path d="M13.157,406.863L710.483,406.863" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:1.1px;"/>
        </g>
        <g transform="matrix(2.5525,0,0,12.5986,9485.52,-2931.8)">
            <path d="M13.154,434.712L710.481,434.712" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:1.1px;"/>
        </g>
        <g transform="matrix(2.5525,0,0,12.5986,9485.51,-2337.79)">
            <path d="M13.157,406.863L710.483,406.863" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:1.1px;"/>
        </g>
        <g transform="matrix(0.912095,0,0,2.92715,-8649.23,-2590.99)">
            <g transform="matrix(54.1667,0,0,54.1667,19761.3,1065.11)">
            </g>
            <text x="19320.5px" y="1065.11px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:54.167px;fill:white;">08:00 Registr<tspan x="19639.6px " y="1065.11px ">a</tspan>tion</text>
        </g>
        <g transform="matrix(0.912095,0,0,2.92715,-8296.66,-4771.19)">
            <text x="18933.9px" y="2861.41px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:54.167px;fill:white;">19:30 Social Dinner</text>
            <g transform="matrix(41.6667,0,0,41.6667,19614.9,2924.49)">
            </g>
            <text x="19099.3px" y="2924.49px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:41.667px;fill:white;">MESSE Dresden - Courtyard</text>
        </g>
        <g transform="matrix(3.45909,0,0,12.1964,10168.8,-3519.31)">
            <rect x="263.268" y="363.576" width="57.834" height="3.915" style="fill:rgb(136,198,102);"/>
        </g>
        <g transform="matrix(3.45909,0,0,12.1964,10168.8,-1985.73)">
            <rect x="263.268" y="363.576" width="57.834" height="3.915" style="fill:rgb(136,198,102);"/>
        </g>
        <g transform="matrix(3.45909,0,0,12.1964,10168.8,-1336.97)">
            <rect x="263.268" y="363.576" width="57.834" height="3.915" style="fill:rgb(136,198,102);"/>
        </g>
        <g transform="matrix(3.45909,0,0,12.1964,10168.8,-2629.64)">
            <rect x="263.268" y="363.576" width="57.834" height="3.915" style="fill:rgb(136,198,102);"/>
        </g>
		
    </g>
<a href="https://chipssummit.org"><image href="Chipssummit_Block_small.svg" x="10" y="180" width="650px"></image></a>
</svg>



					</div>
					</div>
					`,
				},

				{
					type: "html",
					value: `

					<h2>Thursday, May 15<sup>th</sup></h2>
										<div style="max-width=100%; display: flex; flex: 0 0 auto;justify-content: center">
					<div style="border: 3px solid white; width: 90%; height: 90%;overflow-x: auto;">
<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg width="100%" height="100%" viewBox="0 0 2666 3196" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:10;">
    <g id="Thursday-Website-Detailed" serif:id="Thursday Website Detailed" transform="matrix(1.09645,0,0,0.857714,-9761.85,-152.348)">
        <rect x="8903.17" y="177.622" width="2430.92" height="3725.94" style="fill:none;"/>
        <clipPath id="_clip1">
            <rect x="8903.17" y="177.622" width="2430.92" height="3725.94"/>
        </clipPath>
        <g clip-path="url(#_clip1)">
            <g transform="matrix(3.80016,0,0,4.85788,8907.83,-4.27466)">
                <text x="12.917px" y="31.46px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:18px;fill:white;">Thursda<tspan x="78.671px 87.05px " y="31.46px 31.46px ">y,</tspan> Ma<tspan x="120.413px " y="31.46px ">y</tspan> 15</text>
                <text x="154.37px" y="25.466px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10.494px;fill:white;">th</text>
                <text x="12.917px" y="60.46px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:13px;fill:white;">08:00 Registr<tspan x="89.5px " y="60.46px ">a</tspan>tion</text>
                <text x="12.917px" y="90.89px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:13px;fill:white;">PLENARY OPENING SESSION</text>
                <text x="12.917px" y="104.89px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">HALL 3 EAST</text>
                <text x="12.917px" y="130.76px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">08:45 <tspan x="52.667px 62.697px " y="130.76px 130.76px ">We</tspan>lcome Address b<tspan x="139.427px " y="130.76px ">y</tspan></text>
                <text x="146.477px" y="130.76px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Gerhard F<tspan x="191.067px " y="130.76px ">e</tspan>ttweis</text>
                <text x="226.417px" y="130.76px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(5G Lab<tspan x="260.127px " y="130.76px ">)</tspan> and</text>
                <text x="283.207px" y="130.76px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">F<tspan x="288.522px 292.462px " y="130.76px 130.76px ">ra</tspan>nk Fitzek</text>
                <text x="340.507px" y="130.76px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(5G Lab<tspan x="374.217px " y="130.76px ">)</tspan></text>
                <text x="12.917px" y="144.63px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">09:15</text>
                <text x="52.667px" y="144.63px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Sebastian Gemk<tspan x="124.322px " y="144.63px ">o</tspan>w</text>
                <text x="139.847px" y="144.63px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(Sax<tspan x="157.957px " y="144.63px ">o</tspan>n State Ministry for Science, Culture and T<tspan x="345.677px " y="144.63px ">o</tspan>urism): Greeting</text>
                <text x="12.917px" y="158.5px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">09:20</text>
                <text x="52.667px" y="158.5px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Ari K<tspan x="75.107px " y="158.5px ">y</tspan>näslahti</text>
                <text x="117.872px" y="158.5px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(Nokia): Building F<tspan x="197.572px " y="158.5px ">u</tspan>ture Ready Radio Network</text>
                <text x="12.917px" y="172.37px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">09:35 <tspan x="52.667px " y="172.37px ">P</tspan>itch: Cadami &amp; AeroLiFi</text>
                <text x="12.917px" y="186.24px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">09:40</text>
                <text x="52.667px" y="186.24px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">P<tspan x="58.767px " y="186.24px ">e</tspan>iying Zhu</text>
                <text x="107.127px" y="186.24px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(Huawei): 6G: P<tspan x="174.697px " y="186.24px ">o</tspan>wering Liv<tspan x="225.037px " y="186.24px ">e</tspan> Ph<tspan x="243.717px " y="186.24px ">y</tspan>sical AI</text>
                <text x="12.917px" y="200.11px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">09:55 <tspan x="52.667px " y="200.11px ">P</tspan>itch: Allbesmart</text>
                <text x="12.917px" y="213.98px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">10:00</text>
                <text x="52.667px" y="213.98px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Jun<tspan x="68.227px " y="213.98px ">y</tspan>i Li</text>
                <text x="88.012px" y="213.98px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(<tspan x="90.812px " y="213.98px ">Q</tspan>ualcomm): Shaping the F<tspan x="204.512px " y="213.98px ">u</tspan>ture of Mobile Connectivity With 6G</text>
                <text x="12.917px" y="241.72px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:13px;fill:white;">10:20 Coffee Break and Exhibition</text>
                <text x="12.917px" y="454.72px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:13px;fill:white;">13:00 Lunch Break and Exhibition</text>
                <text x="12.917px" y="612.72px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:13px;fill:white;">15:40 Coffee Break and Exhibition</text>
                <text x="12.917px" y="640.15px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:13px;fill:white;">PLENARY CL<tspan x="88.714px " y="640.15px ">O</tspan>SING SESSION</text>
                <text x="12.917px" y="654.15px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">HALL 3 EAST</text>
                <text x="12.917px" y="679.02px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">17:00</text>
                <text x="52.667px" y="679.02px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Sumei Sun</text>
                <text x="100.787px" y="679.02px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(Institute for Infocomm Research (I</text>
                <text x="252.857px" y="675.69px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:5.83px;fill:white;">2</text>
                <text x="256.239px" y="679.02px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">R)):  Nativ<tspan x="298.969px " y="679.02px ">e</tspan> AI in 6G Non-<tspan x="364.309px 369.159px " y="679.02px 679.02px ">Te</tspan>rrestrial Communication Systems and Networks:</text>
                <text x="52.667px" y="691.89px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;"><tspan x="52.667px " y="691.89px ">O</tspan>pportunities and Challenges</text>
                <text x="12.917px" y="705.76px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">17:15</text>
                <text x="52.667px" y="704.76px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">Pitch: Augusta Space GmbH</text>
                <text x="12.917px" y="717.63px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">17:20</text>
                <text x="52.667px" y="717.63px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Bruno Jacobfeuerborn</text>
                <text x="155.062px" y="717.63px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(Deutsche F<tspan x="207.222px " y="717.63px ">u</tspan>nkturm): 5G as a Solid Groundbase for 6G</text>
                <text x="12.917px" y="730.5px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">17:35 <tspan x="52.667px " y="730.5px ">P</tspan>itch: phine.tech</text>
                <text x="12.917px" y="744.37px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">17:40</text>
                <text x="52.667px" y="744.37px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Mischa Dohler</text>
                <text x="119.582px" y="744.37px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(Ericsson): The Dawn of an Immersiv<tspan x="277.272px " y="744.37px ">e</tspan> Internet: XR, Gener<tspan x="369.192px " y="744.37px ">a</tspan>tiv<tspan x="385.542px " y="744.37px ">e</tspan> AI and the Road to 6G</text>
                <text x="12.917px" y="758.24px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">17:55 <tspan x="52.667px 58.527px " y="758.24px 758.24px ">Pa</tspan>nel Discussion:</text>
                <text x="130.357px" y="758.24px" style="font-family:'Lato-Italic', 'Lato', sans-serif;font-style:italic;font-size:10px;fill:white;">Wh<tspan x="144.857px " y="758.24px ">y</tspan> Is 6G a Good Idea?</text>
                <text x="229.002px" y="758.24px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">with</text>
                <text x="250.442px" y="758.24px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Gerhard F<tspan x="295.032px " y="758.24px ">e</tspan>ttweis</text>
                <text x="330.382px" y="758.24px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(5G Lab<tspan x="364.092px " y="758.24px ">)</tspan>,</text>
                <text x="371.142px" y="758.24px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">F<tspan x="376.457px 380.397px " y="758.24px 758.24px ">ra</tspan>nk Fitzek</text>
                <text x="428.442px" y="758.24px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(5G Lab<tspan x="462.152px " y="758.24px ">)</tspan>,</text>
                <text x="469.202px" y="758.24px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Sumei Sun</text>
                <text x="517.322px" y="758.24px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(Institute for</text>
                <text x="52.667px" y="772.11px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;"><tspan x="52.667px " y="772.11px ">I</tspan>nfocomm Research (I</text>
                <text x="147.397px" y="768.78px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:5.83px;fill:white;">2</text>
                <text x="150.779px" y="772.11px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">R)),</text>
                <text x="169.199px" y="772.11px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Ari K<tspan x="191.639px " y="772.11px ">y</tspan>näslahti</text>
                <text x="234.404px" y="772.11px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(Nokia),</text>
                <text x="270.444px" y="772.11px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">P<tspan x="276.544px " y="772.11px ">e</tspan>iying Zhu</text>
                <text x="324.904px" y="772.11px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(Huawei) and</text>
                <text x="384.554px" y="772.11px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Bruno Jacobfeuerborn</text>
                <text x="486.949px" y="772.11px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(Deutsche F<tspan x="539.109px " y="772.11px ">u</tspan>nkturm)</text>
                <text x="12.917px" y="785.98px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">18:45 <tspan x="52.667px " y="785.98px ">S</tspan>ummary with</text>
                <text x="117.537px" y="785.98px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">Gerhard F<tspan x="162.127px " y="785.98px ">e</tspan>ttweis</text>
                <text x="197.477px" y="785.98px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(5G Lab<tspan x="231.187px " y="785.98px ">)</tspan> and</text>
                <text x="254.267px" y="785.98px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:10px;fill:white;">F<tspan x="259.582px 263.522px " y="785.98px 785.98px ">ra</tspan>nk Fitzek</text>
                <text x="311.567px" y="785.98px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">(5G Lab<tspan x="345.277px " y="785.98px ">)</tspan></text>
            </g>
            <g transform="matrix(3.80016,0,0,4.85788,10480.5,-188.485)">
                <text x="46.402px" y="310.228px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:11px;fill:white;">HARDW<tspan x="88.818px " y="310.228px ">A</tspan>RE &amp; WIRELESS</text>
                <text x="81.927px" y="321.228px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">HAMBUR<tspan x="125.467px " y="321.228px ">G</tspan> 2</text>
                <text x="12.914px" y="342.728px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">11:30</text>
                <text x="41.26px" y="342.728px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">K<tspan x="46.672px 50.816px " y="342.728px 342.728px ">ev</tspan>in Schultz</text>
                <text x="91.112px" y="342.728px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(Emerson (NI)): Inno<tspan x="161.016px " y="342.728px ">v</tspan>ativ<tspan x="178.192px " y="342.728px ">e</tspan></text>
                <text x="41.26px" y="352.048px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">T<tspan x="45.14px " y="352.048px ">e</tspan>sting for T<tspan x="83.908px " y="352.048px ">r</tspan>ustworth<tspan x="119.14px " y="352.048px ">y</tspan> AI in Green Wireless</text>
                <text x="41.26px" y="361.368px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Systems</text>
                <text x="12.914px" y="370.864px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">11:50</text>
                <text x="41.26px" y="370.864px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Christina Geßner</text>
                <text x="104.424px" y="370.864px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(Rohde &amp; Schwarz):</text>
                <text x="41.26px" y="380.36px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">AI/ML in 5G-<tspan x="86.276px " y="380.36px ">A</tspan>dvanced and 6G: Pr<tspan x="159.284px " y="380.36px ">a</tspan>ctical</text>
                <text x="41.26px" y="389.856px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">P<tspan x="45.948px " y="389.856px ">a</tspan>ths and Real Challenges</text>
                <text x="12.914px" y="399.356px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">12:10</text>
                <text x="41.26px" y="399.356px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Matthias L<tspan x="79.008px " y="399.356px ">o</tspan>hrmann</text>
                <text x="112.936px" y="399.356px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(SpiNNcloud): How Br<tspan x="189.664px " y="399.356px ">a</tspan>in-</text>
                <text x="41.26px" y="408.676px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Inspired Chips Help Reducing Energy</text>
                <text x="41.26px" y="417.996px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Consumption in the Data Center</text>
                <text x="12.914px" y="427.496px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">12:30</text>
                <text x="41.26px" y="427.496px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Ana García Armada</text>
                <text x="112.34px" y="427.496px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(UC3M): Multicarrier</text>
                <g transform="matrix(8,0,0,8,105.548,436.816)">
                </g>
                <text x="41.26px" y="436.816px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">W<tspan x="49.06px 52.988px 56.98px " y="436.816px 436.816px 436.816px ">ave</tspan>forms for 6G</text>
            </g>
            <g transform="matrix(3.80016,0,0,4.85788,8973.9,-188.485)">
                <text x="247.623px" y="310.228px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:11px;fill:white;">NETWORK &amp; CL<tspan x="328.693px " y="310.228px ">O</tspan>UD</text>
                <text x="271.401px" y="321.228px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">HAMBUR<tspan x="314.941px " y="321.228px ">G</tspan> 1</text>
                <text x="202.318px" y="342.728px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">11:30</text>
                <text x="230.664px" y="342.728px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Anita Döhler</text>
                <text x="278.22px" y="342.728px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(NGMN Alliance<tspan x="335.38px " y="342.728px ">)</tspan>: NGMN&apos;s View</text>
                <text x="230.664px" y="352.048px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Be<tspan x="239.928px 243.92px " y="352.048px 352.048px ">yo</tspan>nd 5G</text>
                <text x="202.318px" y="361.568px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">11:50</text>
                <text x="230.664px" y="361.568px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">P<tspan x="235.544px " y="361.568px ">e</tspan>tar P<tspan x="256.796px " y="361.568px ">o</tspan>po<tspan x="270.284px " y="361.568px ">v</tspan>ski</text>
                <text x="286.172px" y="361.568px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(Univ<tspan x="304.9px " y="361.568px ">e</tspan>rsity of Aalborg): T<tspan x="372.764px " y="361.568px ">o</tspan>wards</text>
                <text x="230.664px" y="370.888px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Real Time in Wireless 6G Communications: How</text>
                <text x="230.664px" y="380.208px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Latency Gets Complicated</text>
                <text x="202.318px" y="389.708px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">12:10</text>
                <text x="230.568px" y="389.708px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Christian Wietfeld</text>
                <text x="298.22px" y="389.708px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(TU Dortmund): 6G</text>
                <text x="230.664px" y="399.028px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">mmW<tspan x="251.6px 255.528px 259.52px " y="399.028px 399.028px 399.028px ">ave</tspan> Industrial Networks: Opportunities,</text>
                <text x="230.664px" y="408.348px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Challenges, and Insights from Real-<tspan x="352.432px 360.456px " y="408.348px 408.348px ">Wo</tspan>rld</text>
                <text x="230.664px" y="417.668px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Deplo<tspan x="251.688px " y="417.668px ">y</tspan>ments</text>
                <text x="202.318px" y="427.168px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">12:30</text>
                <text x="230.664px" y="427.168px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Slawomir Stanczak</text>
                <text x="299.672px" y="427.168px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(F<tspan x="306.36px 309.432px " y="427.168px 427.168px ">ra</tspan>unhofer HHI): T<tspan x="367.168px " y="427.168px ">a</tspan>sk-</text>
                <text x="230.664px" y="436.488px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Oriented 6G: Semantic Communication and</text>
                <text x="230.664px" y="445.808px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Distributed Intelligence With Applications to</text>
                <g transform="matrix(8,0,0,8,310.312,455.128)">
                </g>
                <text x="230.664px" y="455.128px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Collabor<tspan x="260.736px " y="455.128px ">a</tspan>tiv<tspan x="273.816px " y="455.128px ">e</tspan> Robotics</text>
            </g>
            <g transform="matrix(3.80016,0,0,4.85788,10479.6,-179.11)">
                <text x="46.511px" y="511.615px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:11px;fill:white;">HARDW<tspan x="88.927px " y="511.615px ">A</tspan>RE &amp; WIRELESS</text>
                <text x="81.248px" y="523.265px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">HAMBUR<tspan x="124.788px " y="523.265px ">G</tspan> 2</text>
                <text x="13.154px" y="544.765px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">14:30</text>
                <text x="41.5px" y="544.765px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Khaled L<tspan x="72.352px " y="544.765px ">e</tspan>taief</text>
                <text x="94.704px" y="544.765px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(Hong K<tspan x="122.984px " y="544.765px ">o</tspan>ng Univ<tspan x="153.84px " y="544.765px ">e</tspan>rsity of</text>
                <text x="41.5px" y="554.085px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Science and T<tspan x="88.036px " y="554.085px ">e</tspan>chnology): Harnessing AI and</text>
                <text x="41.5px" y="563.405px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Machine L<tspan x="77.3px " y="563.405px ">e</tspan>arning for F<tspan x="121.548px " y="563.405px ">u</tspan>ture Wireless</text>
                <text x="41.5px" y="572.725px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Communications</text>
                <text x="13.154px" y="582.245px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">14:50</text>
                <text x="41.5px" y="582.245px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Reinaldo V<tspan x="79.928px " y="582.245px ">a</tspan>lenzuela</text>
                <text x="115.588px" y="582.245px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(Nokia Bell Labs):6G</text>
                <text x="41.5px" y="591.565px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Vision, Opportunities and Challenges</text>
                <text x="13.154px" y="601.085px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">15:10</text>
                <text x="41.5px" y="601.085px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Janne K<tspan x="69.512px " y="601.085px ">o</tspan>lu</text>
                <text x="82.32px" y="601.085px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(K<tspan x="90.024px 94.112px " y="601.085px 601.085px ">ey</tspan>sight): Modeling and</text>
                <g transform="matrix(8,0,0,8,203.54,610.405)">
                </g>
                <text x="41.5px" y="610.405px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Emulation Ne<tspan x="88.74px " y="610.405px ">x</tspan>t Gener<tspan x="119.076px " y="610.405px ">a</tspan>tion Wireless Channels</text>
            </g>
            <g transform="matrix(3.80016,0,0,4.85788,8973.98,-176.826)">
                <text x="247.732px" y="511.615px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:11px;fill:white;">NETWORK &amp; CL<tspan x="328.802px " y="511.615px ">O</tspan>UD</text>
                <text x="271.474px" y="522.615px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">HAMBUR<tspan x="315.014px " y="522.615px ">G</tspan> 1</text>
                <text x="202.557px" y="544.115px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">14:30</text>
                <text x="230.903px" y="544.115px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Marcos Katz</text>
                <text x="277.371px" y="544.115px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(Univ<tspan x="296.099px " y="544.115px ">e</tspan>rsity of Oulu): Z<tspan x="354.475px " y="544.115px ">e</tspan>ro-Energy</text>
                <text x="230.903px" y="553.435px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">IoT Through Activ<tspan x="293.639px " y="553.435px ">e</tspan> Energy Networking.</text>
                <text x="202.557px" y="562.935px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">14:50</text>
                <text x="230.903px" y="562.935px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Chan-By<tspan x="261.771px " y="562.935px ">o</tspan>ung Chae</text>
                <text x="301.019px" y="562.935px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(Y<tspan x="307.811px " y="562.935px ">o</tspan>nsei Univ<tspan x="344.291px " y="562.935px ">e</tspan>rsity):</text>
                <text x="230.903px" y="572.255px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Exploring the 6G F<tspan x="295.359px " y="572.255px ">r</tspan>ontier: Prototyping K<tspan x="372.407px 376.495px " y="572.255px 572.255px ">ey</tspan></text>
                <text x="230.903px" y="581.575px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">T<tspan x="234.783px " y="581.575px ">e</tspan>chnologies at Y<tspan x="290.871px " y="581.575px ">o</tspan>nsei</text>
                <text x="202.557px" y="591.075px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">15:10</text>
                <text x="230.807px" y="591.075px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Sabrina Engelmann</text>
                <text x="300.839px" y="591.075px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(BSI): BSI Insights: Security</text>
                <g transform="matrix(8,0,0,8,299.831,600.395)">
                </g>
                <text x="230.903px" y="600.395px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">of 5G/6G Networks</text>
            </g>
            <g transform="matrix(3.80016,0,0,4.85788,7486.08,-179.11)">
                <text x="447.986px" y="511.615px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:11px;fill:white;">APPLICA<tspan x="493.064px " y="511.615px ">T</tspan>IONS</text>
                <text x="457.976px" y="523.265px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">HALL 3 EAST</text>
                <text x="391.959px" y="544.785px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">14:30</text>
                <text x="420.305px" y="544.785px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Matthias Stege</text>
                <text x="475.693px" y="544.785px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(Ex<tspan x="486.533px " y="544.785px ">e</tspan>lonix): Securing Critical</text>
                <text x="420.305px" y="554.105px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Infr<tspan x="432.977px " y="554.105px ">a</tspan>structures With Cellular IoT<tspan x="533.929px " y="554.105px ">-</tspan>Sensor</text>
                <text x="391.959px" y="563.605px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">14:50 <tspan x="420.305px 424.993px " y="563.605px 563.605px ">Pa</tspan>nel:</text>
                <text x="443.297px" y="563.605px" style="font-family:'Lato-Italic', 'Lato', sans-serif;font-style:italic;font-size:8px;fill:white;">6G for Healthcar<tspan x="497.997px " y="563.605px ">e</tspan></text>
                <text x="503.229px" y="563.605px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">with</text>
                <text x="520.381px" y="563.605px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Jak<tspan x="532.237px " y="563.605px ">o</tspan>b Kather</text>
                <text x="420.305px" y="572.925px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(EKFZ),</text>
                <text x="447.961px" y="572.925px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Stefanie Speidel</text>
                <text x="506.961px" y="572.925px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(NCT Dresden),</text>
                <text x="420.305px" y="582.245px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Thomas Neumuth</text>
                <text x="487.013px" y="582.245px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(ICCAS),</text>
                <text x="518.149px" y="582.245px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Nor<tspan x="531.897px " y="582.245px ">a</tspan> Herzog</text>
                <text x="420.305px" y="591.565px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(<tspan x="422.545px " y="591.565px ">C</tspan>onnCons),</text>
                <text x="464.857px" y="591.565px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Ralf Irmer</text>
                <g transform="matrix(8,0,0,8,540.813,591.565)">
                </g>
                <text x="502.405px" y="591.565px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(V<tspan x="509.781px " y="591.565px ">o</tspan>dafone<tspan x="538.413px " y="591.565px ">)</tspan></text>
            </g>
            <g transform="matrix(-1.34074e-12,-9.48102,-4.149,-1.87125e-12,12670.7,5614.54)">
                <path d="M374.871,521.33L457.301,521.33" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.63px;"/>
            </g>
            <g transform="matrix(-2.52786e-13,-7.1517,-4.149,-3.5281e-13,11891.6,5445.14)">
                <path d="M369.76,333.331L444.133,333.331" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.77px;"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8903.32,-3667.02)">
                <path d="M12.441,825.236L570.5,825.236" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.91px;stroke-linecap:round;"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8903.32,-3918.32)">
                <path d="M12.441,849.856L570.5,849.856" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.91px;stroke-linecap:round;"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8903.32,-2004.53)">
                <path d="M12.681,635.478L570.74,635.478" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.91px;stroke-linecap:round;"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8903.34,-1728.77)">
                <path d="M12.914,605.823L570.973,605.823" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.91px;stroke-linecap:round;"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8904.23,-4.15571)">
                <path d="M13.154,434.712L571.213,434.712" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.91px;stroke-linecap:round;"/>
            </g>
            <g transform="matrix(-1.23001e-12,-9.2217,-4.149,-1.71725e-12,11878.9,3757.48)">
                <path d="M184.033,520.171L268.781,520.171" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.65px;"/>
            </g>
            <g transform="matrix(-2.87636e-13,-7.38536,-4.149,-4.01449e-13,11109.6,4139.49)">
                <path d="M181.273,334.508L253.293,334.508" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.76px;"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8903.32,1560.29)">
                <path d="M12.914,270.606L570.973,270.606" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.91px;stroke-linecap:round;"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8903.32,1822.54)">
                <path d="M12.561,243.734L570.62,243.734" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.91px;stroke-linecap:round;"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8900.85,262.838)">
                <path d="M13.157,406.863L571.216,406.863" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.91px;stroke-linecap:round;"/>
            </g>
            <g transform="matrix(3.86405,0,0,4.85788,9043.79,-1337.6)">
                <rect x="451.829" y="563.316" width="59.043" height="3.915" style="fill:rgb(82,176,203);"/>
            </g>
            <g transform="matrix(3.52106,0,0,4.85788,9204.32,633.352)">
                <rect x="450.252" y="361.988" width="62.671" height="3.915" style="fill:rgb(82,176,203);"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8904.22,-1337.6)">
                <rect x="263.268" y="563.316" width="57.834" height="3.915" style="fill:rgb(136,198,102);"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8904.22,625.637)">
                <rect x="263.268" y="363.576" width="57.834" height="3.915" style="fill:rgb(136,198,102);"/>
            </g>
            <g transform="matrix(3.80016,0,0,4.85788,7468.3,-188.485)">
                <text x="447.878px" y="310.228px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:11px;fill:white;">APPLICA<tspan x="492.956px " y="310.228px ">T</tspan>IONS</text>
                <text x="457.868px" y="321.878px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:10px;fill:white;">HALL 3 EAST</text>
                <text x="391.722px" y="343.378px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">11:30</text>
                <text x="420.068px" y="343.378px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Mark Beckmann</text>
                <text x="480.2px" y="343.378px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(V<tspan x="487.576px " y="343.378px ">o</tspan>lkswagen):</text>
                <text x="420.068px" y="352.698px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Connectivity@<tspan x="471.444px 476.42px " y="352.698px 352.698px ">Vo</tspan>lkswagen – Opportunities</text>
                <text x="420.068px" y="362.018px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">and Challenges</text>
                <text x="391.722px" y="371.518px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">11:50</text>
                <text x="420.068px" y="371.518px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Ulrich Viethen</text>
                <text x="473.54px" y="371.518px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(Murrelektronik): Customer</text>
                <text x="420.068px" y="380.838px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Expectations on Communication for</text>
                <text x="420.068px" y="390.158px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Decentr<tspan x="448.716px " y="390.158px ">a</tspan>lized Electrical Automation</text>
                <text x="391.722px" y="399.658px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">12:10</text>
                <text x="419.972px" y="399.658px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Damian Dudek</text>
                <text x="474.644px" y="399.658px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(VDE):  The T<tspan x="519.444px " y="399.658px ">o</tspan>uch of Photonics</text>
                <text x="420.068px" y="408.978px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">in Digital Electronics - T<tspan x="501.676px " y="408.978px ">o</tspan>wards Energy</text>
                <g transform="matrix(8,0,0,8,427.412,418.298)">
                </g>
                <g transform="matrix(8,0,0,8,430.004,418.298)">
                </g>
                <text x="420.068px" y="418.298px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Efﬁcient Data Centers for Gener<tspan x="532.812px " y="418.298px ">a</tspan>tiv<tspan x="545.892px " y="418.298px ">e</tspan> AI</text>
                <text x="420.068px" y="427.618px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Applications.</text>
                <text x="391.722px" y="437.118px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">12:30</text>
                <text x="420.068px" y="437.118px" style="font-family:'Lato-Bold', 'Lato', sans-serif;font-weight:700;font-size:8px;fill:white;">Dominic Schupk<tspan x="477.476px " y="437.118px ">e</tspan></text>
                <text x="483.296px" y="437.118px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">(Airbus): Advances in 6G for</text>
                <g transform="matrix(8,0,0,8,457.244,446.438)">
                </g>
                <text x="420.068px" y="446.438px" style="font-family:'Lato-Regular', 'Lato', sans-serif;font-size:8px;fill:white;">Aerospace</text>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8893.23,-1333.25)">
                <rect x="75.44" y="562.164" width="54.206" height="3.915" style="fill:rgb(200,202,213);"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8901.09,628.159)">
                <rect x="73.26" y="363.057" width="59.043" height="3.915" style="fill:rgb(200,202,213);"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8903.32,-3235.46)">
                <rect x="12.917" y="777.614" width="60.165" height="3.915" style="fill:rgb(200,202,213);"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8904.33,2191.72)">
                <rect x="12.914" y="205.232" width="60.639" height="3.915" style="fill:rgb(200,202,213);"/>
            </g>
            <g transform="matrix(4.149,0,0,4.85788,8903.32,3583.34)">
                <path d="M13.157,55.877L571.219,55.877" style="fill:none;fill-rule:nonzero;stroke:white;stroke-width:0.91px;stroke-linecap:round;"/>
            </g>
        </g>
    </g>
</svg>


					</div>
					</div> 
					</div>`
					//  <div style="width: 100%; display: flex; justify-content: center;">
					//  	<div style="border: 1px solid white; max-width: 95%; overflow-x: auto;">
					//  		<img alt="Agenda" src="Agenda_Wednesday.svg" width="800px">
					//  	</div>
					//  </div>
					// `,
				}
			 ],
		},
		{
			name: "exhibition",
			title: "Exhibition",
			// background: "dark",
			content: [
				// {
				// 	type: "html",
				// 	value: `<p>To be announced.</p>`,
				// }
				{
					type: "html",
					value: `
					<div style="width: 100%; display: flex; justify-content: center;">
					<a class="raw" title="open picture separately" href="exhibition_plan.svg"><img alt="Exhibition Plan" src="exhibition_plan.svg" style="width:1000px; max-width: 95%;"></a>
					</div >
					<sponsors json="data/sponsors.json" pictures="data/sponsors/" :include="['Exhibitors']"></sponsors>
					
					`
				}
				// {
				// 	type: "html",
				// 	value: `

				// 	<!--div class="sponsors-grid">
				// 		<exhibitor name="Barkhausen Institut" number="3a" >
				// 			<p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>
				// 		</exhibitor>
				// 		<exhibitor name="Huawei" number="4a" >
				// 			<p>Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.</p>
				// 		</exhibitor>
				// 	</div-->
				// 	<!--sponsors :headings="true" json="data/sponsors.json" pictures="data/sponsors/" :include="['Exhibitors']"></sponsors-->
				// 	 <p>Interested in becoming an exhibitor at our event? Check our <a href="6GSummit2024_SponsoringFlyer_small.pdf">2024 Patronage Brochure</a>.</p>
				// 	`
				// },
				//<div style="width: 100%; display: flex; justify-content: center;"><div style="border: 1px solid white; max-width: 95%; overflow-x: auto;"><img alt="Exhibition Plan" src="exhibition_plan.svg" width="600px"></div></div>
				// <p>Interested in becoming an exhibitor at our event? Patronage Brochure will be published soon.</p>
			],
		},

		{
			name: "committee",
			title: "Committee",
			background: "dark",
			content: [
				{
					type: "component:organizers",
				},
			],
		},
		{
			name: "Terms and Conditions",
			title: "Terms and Conditions",
			// background: "dark",
			content: [
				{
					
						type: "html",
						value: `
						<p>Our <a href="DCCF25-TermsandConditions.pdf">Terms and Conditions</a> apply.</p>
						`,
					},
			],
		},
	],
};
